<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-form
          ref="form"
          :model="form"
          size="small"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="Ends After"
              >
                <el-date-picker
                  v-model="form.endDate"
                  type="date"
                  placeholder="Select Date"
                  size="small"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                class="float-right"
                @click.native="downloadCSV()"
              >
                Export
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Fuel Report"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
      :is-direct-download="true"
    />
  </div>
</template>

<script>
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    Preview
  },
  data () {
    return {
      pageTitle: 'Fuel Report',
      breadcrumb: {
        name: 'Fuel Report',
        route: { name: 'reports-invoice-fuel' }
      },
      form: {},
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    downloadCSV () {
      this.configuration = {
        report: 'FuelReport',
        params: this.form
      }
      this.isShowPreview = true
    }
  }
}
</script>
